import React, {useState, useEffect,useCallback } from 'react';
import { useInView } from 'react-intersection-observer';
import { GoStarFill } from "react-icons/go";
export default function Workflow() {
  const steps = [
    'Richiesta preventivo',
    'Supervisione in luogo del lavoro',
    'Messa in posa del serramento',
    'Pulizia e rifinitura'
    //'Cliente soddisfatto',
  ];
  const { ref, inView, entry  } = useInView({
    threshold: 0.2, // Quando il 50% dell'elemento è visibile
    triggerOnce: true, // Triggera solo una volta
  });
  const [scrollPosition, setScrollPosition] = useState(0);
  const [initialScroll, setInitialScroll] = useState(0);
  // Funzione per aggiornare la posizione della freccia al movimento della pagina
  useEffect(() => {
    if (inView) {
        setInitialScroll(window.scrollY);
    }
}, [inView]);


  const handleScroll = useCallback(() =>  {
    if (inView) {
        
      const scroll = window.scrollY;
      const scrolled = scroll - initialScroll;
        const elementHeight = entry?.boundingClientRect.height;
      const percentage = (scrolled / elementHeight) * 100;
        console.log('scroll', scroll);
        console.log('initialScroll', initialScroll);
        console.log('elementHeight', elementHeight);

        
      if (percentage<0) {
        setScrollPosition(0);     
        return;
      }
      if(percentage>100)
      {
        setScrollPosition(100)
        return;
      }
      setScrollPosition(percentage);
    }
  }, [inView, initialScroll, entry]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);
  
  return (
    <>
    <div ref={ref} className="flex flex-col items-center justify-center mt-20 relative">
      {/* Freccia centrale */}
      <div  className="absolute w-2 h-full bg-logo-color4"></div>
      <div
          className="h-4 w-4 border-x-8 border-x-transparent border-t-[16px] border-logo-color"
          style={{
            position: 'absolute',
            top: `${scrollPosition}%`,
            transform: 'translateY(-50%)',
            transition: 'top 0.3s ease-out',
          }}
        ></div>
      {steps.map((step, index) => (
        <Step key={index} step={step} index={index} />
      ))}
        
    </div>
    <div className="flex flex-col items-center justify-center  w-full">
        {/* <Link to="/recensioni">
        <div className='bg-logo-color4  text-white  w-56 rounded-lg shadow-lg px-6 py-3'>
            <p className="text-center text-white text-lg font-bold">Lascia una recensione positiva!</p>
            <div className='flex items-center justify-center text-logo-color text-3xl'>
            <GoStarFill />
            <GoStarFill />
            <GoStarFill />
            <GoStarFill />
            <GoStarFill />
            </div>
            

        </div>
        </Link> */}
        <div className='bg-logo-color4  text-white  w-56 rounded-lg shadow-lg px-6 py-3'>
            <p className="text-center text-white text-lg font-bold">Cliente soddisfatto!</p>
            <div className='flex items-center justify-center text-logo-color text-3xl'>
            <GoStarFill />
            <GoStarFill />
            <GoStarFill />
            <GoStarFill />
            <GoStarFill />
            </div>
            

        </div>
      </div>
    </>

  );
}

function Step({ step, index }) {
  const { ref, inView } = useInView({
    threshold: 0.5, // Quando il 50% dell'elemento è visibile
    triggerOnce: true, // Triggera solo una volta
  });

  return (
    <div
      ref={ref}
      className={`relative flex items-center my-10 w-full max-w-lg transition-all duration-700 ease-in-out transform 
        ${inView
          ? index % 2 === 0
            ? 'opacity-100 translate-x-0'
            : 'opacity-100 translate-x-0'
          : index % 2 === 0
          ? 'opacity-0 -translate-x-10' // A sinistra, arriva da sinistra
          : 'opacity-0 translate-x-10'  // A destra, arriva da destra
          } ${index % 2 === 0 ? 'justify-start' : 'justify-end'}`}
    >
      {/* Linea collegata alla freccia */}
      <div className={`absolute w-1/2 h-2 rounded-lg bg-logo-color4 `}></div>

      {/* Step box */}
      <div className=" z-10 bg-logo-color4 text-white px-6 py-3 rounded-lg shadow-lg w-5/12 sm:w-56">
        <p className="text-center text-sm sm:text-base font-semibold">{step}</p>

      </div>
    </div>
  );
}
